<template>
    <div class="NewTableAction">
        <slot />
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
